import { Component, ViewChild } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { QuoteService } from 'app/quote/quote.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { ModalTaskDetailsComponent } from '../modal-task-details/modal-task-details.component';

@Component({
	selector: 'modal-view-dependency',
	templateUrl: './modal-view-dependency.component.html'
})
export class ModalViewDependencyComponent extends UIModalBaseComponent {

	@ViewChild(ModalTaskDetailsComponent, { static: false }) modalTaskDetails: ModalTaskDetailsComponent;

	dependency;
	id;
	currentIndex = 0;
	image_urls = [];
	image;
	from = 'task';

	constructor(
		public app: AppService,
		private api: ApiService,
		public service: QuoteService
	) {
		super();
	}

	open(mdata) {
		this.id = mdata.id || null;
		this.image_urls = [];
		this.image = null;
		this.from = mdata.from || 'task';
		this.dependency = null;
		this.refresh();
	}

	refresh() {
		this.currentIndex = 0;
		if (this.id) {
			this.api.task.getDependencyOutcome(this.id, (data) => {
				this.dependency = data;
				this.image_urls = this.dependency['image_urls'];
				if (this.image_urls.length) {
					this.image = this.image_urls[0];
				} else {
					this.image = this.dependency['image_url'];
				}
				if (!this.modal.isOpen) this.modal.open();
			}, error => {
				this.app.notifications.showDanger(error.message);
				return;
			});
		}
	}

	next() {
		if (this.currentIndex < this.image_urls.length - 1) {
			this.currentIndex++;
			const newImage = this.image_urls[this.currentIndex];

			this.image = null;
			setTimeout(() => { this.image = newImage; }, 0);
		}
	}

	prev() {
		if (this.currentIndex > 0) {
			this.currentIndex--;
			const newImage = this.image_urls[this.currentIndex];

			this.image = null;
			setTimeout(() => { this.image = newImage; }, 0);
		}
	}

	openTaskDetails(dependency) {
		if (this.from === 'task') return;
		this.modalTaskDetails.open({ id: dependency.parent_id ? dependency.parent_id : dependency.task_id });
	}

	taskDetailsModalClosed(_data) {
		this.refresh();
	}

	goToWorkOrder(dependency) {
		if (dependency.work_order_id) window.open(this.app.org + '/job/' + dependency.work_order_id);
	}

}
